import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../constants'

import { SummaryCell } from './summary-cell'

export const SummaryRow = ({ summary, dates }) => {
  return (
    <HeaderRowSum style={ { position: 'absolute', bottom: 0, right: 0, width: '100%', height: 50, display: 'flex', flexDirection: 'row' } }>
      <CellLeftCol style={ { backgroundColor: '#F7F7F7', width: 200, overflow: 'hidden' } }>Number of People</CellLeftCol>
      <div style={ { flex: 1, overflow: 'hidden', display: 'flex' } }>
        {dates.map(date => (
          <SummaryCell key={ date } date={ date } summary={ summary } />
        ))}
      </div>
    </HeaderRowSum >
  )
}

const HeaderRowSum = styled.div`
  border: solid #000000;
  border-width: 2px 0px 0px 0px;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`

const CellLeftCol = styled.div`
  display: flex;
  align-items: center;
  padding-left: 1% ;
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/summary-row.js